import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";

import { Translate, I18n } from "react-redux-i18n";

import { setAlert } from "../../../actions/alertActions";

import Modal from "react-bootstrap/Modal";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import ToggleButton from "react-bootstrap/ToggleButton";
import Card from "react-bootstrap/Card";
import Accordion from "react-bootstrap/Accordion";

import RadioCheck from "../../utils/components/RadioCheck";
import ToggleSwitch from "../../utils/components/ToggleSwitch";
import AvailabilityPicker from "../../utils/components/availabilityPicker/AvailabilityPicker";
import CheckCard from "../../utils/components/CheckCard";
import { momentModule } from "../../utils/Utils";

import "../../../styles/components/chargers/modals/AvailabilityAccess.scss";
import public_access from "../../../styles/images/public_access.svg";
import private_access from "../../../styles/images/private_access.svg";
import restrict_access from "../../../styles/images/restrict_access.svg";
import public_access_white from "../../../styles/images/public_access_white.svg";
import private_access_white from "../../../styles/images/private_access_white.svg";
import restrict_access_white from "../../../styles/images/restrict_access_white.svg";
import ArrowCardToggle from "../../utils/components/ArrowCardToggle";

const { moment } = momentModule;

class AvailabilityAccess extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      tabIndex: 1,
      selectedCharger: null,
      fleets: [],
      myFleets: [],

      availability: "Always",
      ranges: [],

      access: "Public",
      mapVisibility: true,
      groups: [],
      collapsed: [],
    };

    this.fetchFleets = this.fetchFleets.bind(this);
    this.handleOnClickAccordion = this.handleOnClickAccordion.bind(this);
    this.handleOnAvailabilityChange =
      this.handleOnAvailabilityChange.bind(this);
    this.handleOnRangeChange = this.handleOnRangeChange.bind(this);
    this.handleOnAccessChange = this.handleOnAccessChange.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
    this.onSave = this.onSave.bind(this);
    this.resetState = this.resetState.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.selectedCharger)
      if (
        prevProps?.selectedCharger?.chargerId !==
        this.props.selectedCharger.chargerId
      )
        this.safeSetState(
          { selectedCharger: this.props.selectedCharger },
          () => {
            const { availabilityType, ...ranges } =
              this.state.selectedCharger.availability ?? {};
            this.safeSetState(
              {
                availability: availabilityType ?? "Always",
                ranges: ranges ?? [],
                access: this.state.selectedCharger.accessType,
                mapVisibility: this.state.selectedCharger.mapVisibility,
              },
              () => {
                this.fetchGroups();
                this.fetchFleets();
              }
            );
          }
        );
  }

  componentWillUnmount() {
    this._mounted = false;
    if (this.cancel) this.cancel("Component is unmounting");
  }

  //This function is very important to manipulate the data from fleets and is working sequencially waiting for promisses to finish
  fetchFleets() {
    this.safeSetState({ fleets: [] }, () => {
      let newFleetGroup = this.state.fleets;
      const listOfFleets = this.props.selectedCharger.listOfFleets;
      const fleetPromises = listOfFleets.map((elem) => this.fetchFleetEvs(elem));
      const myFleetPromises = this.fetchMyFleets();
      myFleetPromises
        .then((myFleetProm) => {
          if (myFleetProm.status === 200) {
            this.safeSetState({ myFleets: myFleetProm.data }, () => {
              Promise.all(fleetPromises)
                .then((fleetPromArray) => {
                  fleetPromArray.forEach((promise, idx) => {
                    if (promise !== undefined && promise.status === 200) {
                      newFleetGroup.push({
                        fleetId: listOfFleets[idx].fleetId,
                        fleetName: listOfFleets[idx].fleetName,
                        evs: promise.data,
                      });
                    }
                  });

                  this.safeSetState(
                    {
                      fleets: newFleetGroup,
                    },
                    () => {
                      let myFleets = this.state.myFleets;
                      const fleets = this.state.fleets;

                      myFleets.forEach((fleet) => {
                        fleet.checked =
                          fleets.findIndex((l) => l.fleetId === fleet._id) !==
                          -1;
                      });

                      this.safeSetState({
                        myFleets: myFleets,
                      });
                    }
                  );
                })
                .catch((err) =>
                  this.props.setAlert(
                    I18n.t(err.response.data.message),
                    "danger"
                  )
                );
            });
          }
        })
        .catch((err) =>
          this.props.setAlert(I18n.t(err.response.data.message), "danger")
        );
    });
  }

  fetchFleetEvs(fleet) {
    return axios.get(
      "/api/private/evs/details",
      { params: { _id: fleet.fleetId } },
      {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      }
    );
  }

  fetchMyFleets() {
    return axios.get("/api/private/fleets/toAddOnChargerB2B", {
      cancelToken: new CancelToken((c) => (this.cancel = c)),
    });
  }

  fetchGroups() {
    axios
      .get("/api/private/groupCSUsers", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        this.safeSetState({
          groups:
            res.data.map((g) =>
              Object.assign({}, g, {
                checked:
                  this.state.selectedCharger.listOfGroups.findIndex(
                    (l) => l.groupId === g._id
                  ) !== -1,
              })
            ) || [],
        });
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleOnAvailabilityChange(e) {
    const name = e.target.name;
    this.safeSetState({
      availability: name,
    });
  }

  handleOnRangeChange(weekDays) {
    let ranges = {};
    Object.keys(weekDays).forEach((weekDay) => {
      const checked = weekDays[weekDay].buttons.filter((b) => b.checked);
      const totalChecked = checked.length;
      const allDay = totalChecked === 24;
      const weekDayObj = {
        isSelected: totalChecked > 0,
        availabilityDay: allDay ? "allDay" : "custom",
      };

      if (!allDay && checked?.length > 0) {
        let counter = 0,
          tempRanges = [],
          startRange = null;
        for (let i = 0; i < weekDays[weekDay].buttons.length; i++) {
          const currBtn = weekDays[weekDay].buttons[i];
          const endRange = () => {
            if (startRange !== null) {
              tempRanges.push({
                startTime: moment.utc({ hour: startRange.name.slice(0, -1) }),
                endTime: moment
                  .utc({ hour: startRange.name.slice(0, -1) })
                  .add(counter, "hours"),
              });
              counter = 0;
              startRange = null;
            }
          };

          if (currBtn.checked) {
            counter++;
            if (startRange === null) startRange = currBtn;
            if (i === weekDays[weekDay].buttons.length - 1) endRange();
          } else if (startRange !== null) endRange();
        }

        Object.assign(weekDayObj, {
          ranges: tempRanges.map((range) => ({
            startTime: range.startTime.format("HH:mm"),
            endTime: range.endTime.format("HH:mm"),
          })),
        });
      }

      Object.assign(ranges, { [weekDay]: weekDayObj });
    });
    this.safeSetState({ ranges });
  }

  handleOnAccessChange(e) {
    const el = e.target;
    this.safeSetState({
      access: el.name,
    });
  }

  handleOnClick(e, idx) {
    this.safeSetState({
      tabIndex: !Number.isNaN(idx) ? idx : 1,
    });
  }

  handleCheck(e, idx) {
    this.safeSetState((prevState) => ({
      groups: [
        ...prevState.groups.slice(0, idx),
        Object.assign({}, prevState.groups[idx], {
          checked: !this.state.groups[idx].checked,
        }),
        ...prevState.groups.slice(idx + 1),
      ],
    }));
  }

  handleFleetCheck(e, idx) {
    e.stopPropagation();
    this.safeSetState((prevState) => ({
      myFleets: [
        ...prevState.myFleets.slice(0, idx),
        Object.assign({}, prevState.myFleets[idx], {
          checked: !this.state.myFleets[idx].checked,
        }),
        ...prevState.myFleets.slice(idx + 1),
      ],
    }));
  }

  onSave(e) {
    e.preventDefault();
    if (this.state.tabIndex === 0) {
      this.props.onSubmit.availability(
        this.state.availability,
        this.state.ranges
      );
    } else {
      this.props.onSubmit.access({
        accessType: this.state.access,
        mapVisibility: this.state.mapVisibility,
        groups: this.state.groups,
        fleets: this.state.myFleets,
      });
    }
  }

  setModal(modal, bool) {
    let newModals = Object.assign({}, this.state.modals);
    newModals[modal] = bool;
    this.safeSetState({
      modals: newModals,
    });
  }

  handleOnClickAccordion(key, e) {
    let newCollapsable = this.state.collapsed;

    newCollapsable[key] = !this.state.collapsed[key];

    this.safeSetState({ collapsed: newCollapsable });
  }

  resetState() {
    this.safeSetState({
      tabIndex: 1,
      selectedCharger: null,
      fleets: [],
      myFleets: [],

      availability: "Always",
      ranges: [],

      access: "Public",
      mapVisibility: true,
      groups: [],
      collapsed: [],
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <>
        <Modal
          id="availabilityAccess"
          show={this.props.show}
          onHide={this.props.onHide}
          onExited={this.resetState}
          centered
        >
          <Modal.Header>
            <div id="TemporaryFixDiv">
              <p
                className={this.state.tabIndex === 1 ? "selected" : ""}
                onClick={(e) => this.handleOnClick(e, 1)}
                id="temporaryFixP"
              >
                <b>
                  <Translate value="availabilityAccess_access" />
                </b>
              </p>
            </div>
            {/*
            <div className="tabs">
              <p
                className={this.state.tabIndex === 0 ? "selected" : ""}
                onClick={(e) => this.handleOnClick(e, 0)}
              >
                <Translate value="availabilityAccess_availability" />
              </p>
              <p
                className={this.state.tabIndex === 1 ? "selected" : ""}
                onClick={(e) => this.handleOnClick(e, 1)}
              >
                <Translate value="availabilityAccess_access" />
              </p>
            </div>
             */}
          </Modal.Header>
          <Modal.Body>
            <form
              id="availability-access-form"
              onSubmit={(e) => this.onSave(e)}
            >
              {this.state.tabIndex === 0 ? (
                <>
                  <div className="form-field">
                    <RadioCheck
                      label={<Translate value="availabilityAccess_always" />}
                      labelPos="right"
                      name="Always"
                      checked={this.state.availability === "Always"}
                      onChange={this.handleOnAvailabilityChange}
                    />
                    <RadioCheck
                      label={<Translate value="availabilityAccess_custom" />}
                      labelPos="right"
                      name="Custom"
                      checked={this.state.availability === "Custom"}
                      onChange={this.handleOnAvailabilityChange}
                    />
                  </div>
                  <div className="form-field">
                    {this.state.availability === "Custom" && (
                      <AvailabilityPicker
                        availability={this.state.ranges}
                        onRangeChange={this.handleOnRangeChange}
                      />
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div className="form-field">
                    <div className="access-buttons">
                      <ButtonGroup>
                        <ToggleButton
                          type="checkbox"
                          name="Public"
                          className="evio-toggle-btn"
                          checked={this.state.access === "Public"}
                          onChange={this.handleOnAccessChange}
                        >
                          <img
                            src={
                              this.state.access === "Public"
                                ? public_access_white
                                : public_access
                            }
                            alt="public"
                          />
                          <p>
                            <Translate value="availabilityAccess_public" />
                          </p>
                        </ToggleButton>
                        <ToggleButton
                          type="checkbox"
                          name="Private"
                          className="evio-toggle-btn"
                          checked={this.state.access === "Private"}
                          onChange={this.handleOnAccessChange}
                        >
                          <img
                            src={
                              this.state.access === "Private"
                                ? private_access_white
                                : private_access
                            }
                            alt="private"
                          />
                          <p>
                            <Translate value="availabilityAccess_private" />
                          </p>
                        </ToggleButton>
                        <ToggleButton
                          type="checkbox"
                          name="Restrict"
                          className="evio-toggle-btn"
                          checked={this.state.access === "Restrict"}
                          onChange={this.handleOnAccessChange}
                        >
                          <img
                            src={
                              this.state.access === "Restrict"
                                ? restrict_access_white
                                : restrict_access
                            }
                            alt="restrict"
                          />
                          <p>
                            <Translate value="availabilityAccess_restrict" />
                          </p>
                        </ToggleButton>
                        <ToggleButton
                          type="checkbox"
                          name="FreeCharge"
                          className="evio-toggle-btn"
                          checked={this.state.access === "FreeCharge"}
                          onChange={this.handleOnAccessChange}
                        >
                          <img
                            src={
                              this.state.access === "FreeCharge"
                                ? public_access_white
                                : public_access
                            }
                            alt="free"
                          />
                          <p>
                            <Translate value="availabilityAccess_free" />
                          </p>
                        </ToggleButton>
                      </ButtonGroup>
                      {this.state.access === "Public" && (
                        <>
                          <div className="availabilityText">
                            <Translate value="availabilityAccess_publicText" />
                          </div>
                          <div className="map-visibility-container">
                            <ToggleSwitch
                              name="mapVisibility"
                              label={
                                <Translate value="availabilityAccess_mapVisibility" />
                              }
                              checked={this.state.mapVisibility}
                              onChange={(e) =>
                                this.safeSetState((prevState) => ({
                                  mapVisibility: !prevState.mapVisibility,
                                }))
                              }
                            />
                          </div>
                        </>
                      )}
                      {this.state.access === "Private" && (
                        <div className="availabilityText">
                          <Translate value="availabilityAccess_privateText" />
                        </div>
                      )}
                      {this.state.access === "Restrict" && (
                        <div className="availabilityText">
                          <Translate value="availabilityAccess_restrictText" />
                        </div>
                      )}
                      {this.state.access === "FreeCharge" && (
                        <div className="availabilityText">
                          <Translate value="availabilityAccess_freeText" />
                        </div>
                      )}
                    </div>
                  </div>

                  {(this.state.access === "Public" ||
                    this.state.access === "Restrict") && (
                    <>
                      {this.state.groups &&
                        Array.isArray(this.state.groups) &&
                        this.state.groups.length > 0 && (
                          <Accordion>
                            <ArrowCardToggle eventKey="0">
                              <div className="border-top-title">
                                <Translate value="availabilityAccess_groups" />
                              </div>
                            </ArrowCardToggle>
                            <Accordion.Collapse
                              eventKey="0"
                              className="form-field"
                            >
                              <div className="group-list">
                                {this.state.groups.map((g, i) => (
                                  <CheckCard
                                    key={g._id}
                                    name={g.name || ""}
                                    avatar={g.imageContent}
                                    checked={!!g.checked}
                                    onChange={(e) => this.handleCheck(e, i)}
                                  />
                                ))}
                              </div>
                            </Accordion.Collapse>
                          </Accordion>
                        )}
                      {this.state.myFleets &&
                        Array.isArray(this.state.myFleets) &&
                        this.state.myFleets.length > 0 && (
                          <Accordion>
                            <ArrowCardToggle eventKey="1">
                              <div className="title">
                                <Translate value="availabilityAccess_fleets" />
                              </div>
                            </ArrowCardToggle>
                            <Accordion.Collapse
                              eventKey="1"
                              className="form-field"
                            >
                              <div className="group-list">
                                {this.state.myFleets.map((g, i) => (
                                  <Accordion key={i} id="connectorType">
                                    <Accordion.Toggle
                                      as={Card.Header}
                                      eventKey="0"
                                      key={i}
                                      onClick={(e) =>
                                        this.handleOnClickAccordion(i, e)
                                      }
                                    >
                                      <CheckCard
                                        fleet={true}
                                        collapsed={
                                          this.state.collapsed[i]
                                            ? "arrow"
                                            : "arrow open"
                                        }
                                        key={g._id}
                                        name={g.name || ""}
                                        avatar={g.imageContent}
                                        checked={!!g.checked}
                                        fleetEvs={g.listEvs ? g.listEvs : null}
                                        onChange={(e) =>
                                          this.handleFleetCheck(e, i)
                                        }
                                      />
                                    </Accordion.Toggle>
                                  </Accordion>
                                ))}
                              </div>
                            </Accordion.Collapse>
                          </Accordion>
                        )}
                    </>
                  )}
                </>
              )}
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="submit"
              form="availability-access-form"
              disabled={
                this.state.access === "Restrict" &&
                this.state.groups.filter((g) => g.checked).length === 0 &&
                this.state.myFleets.filter((f) => f.checked).length === 0
              }
            >
              <Translate value="availabilityAccess_save" />
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default connect(null, { setAlert })(AvailabilityAccess);
